import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgArrowX = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M20.8701 12.7395C21.3255 12.7395 21.6946 12.3704 21.6946 11.915V2.86728L20.8825 2.86728C20.8743 2.86716 20.866 2.86716 20.8577 2.86728L12.6469 2.86728C12.1915 2.86728 11.8224 3.23641 11.8224 3.69175C11.8224 4.1471 12.1915 4.51623 12.6469 4.51623L18.8796 4.51623L8.62736 14.7685C8.30538 15.0904 8.30538 15.6125 8.62736 15.9345C8.94933 16.2564 9.47136 16.2564 9.79334 15.9345L20.0457 5.68211V11.915C20.0457 12.3704 20.4148 12.7395 20.8701 12.7395ZM3.3063 6.61016C2.27419 6.61016 1.4375 7.44686 1.4375 8.47897V20.5712C1.4375 21.6033 2.27419 22.44 3.3063 22.44H15.3986C16.4307 22.44 17.2674 21.6033 17.2674 20.5712V16.2264C17.2674 15.8014 16.9228 15.4569 16.4979 15.4569C16.0729 15.4569 15.7284 15.8014 15.7284 16.2264V20.5712C15.7284 20.7534 15.5807 20.901 15.3986 20.901H3.3063C3.12417 20.901 2.97651 20.7534 2.97651 20.5712V8.47897C2.97651 8.29683 3.12417 8.14918 3.3063 8.14918H8.05526C8.48025 8.14918 8.82477 7.80466 8.82477 7.37967C8.82477 6.95468 8.48025 6.61016 8.05526 6.61016H3.3063Z"
	})]
});
const ForwardRef = forwardRef(SvgArrowX);
export { ForwardRef as ReactComponent };
